import { render, staticRenderFns } from "./document-info.vue?vue&type=template&id=6d3efd97&"
import script from "./document-info.vue?vue&type=script&lang=js&"
export * from "./document-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports